import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles(( theme ) => ({
  root: {
    position: "fixed",
    zIndex: 1300,
    bottom: 0,
    width: "100vw",
    padding: "36px 48px",
    backgroundColor: theme.props.backgroundSecondary,
  },
}));

export default useStyle;
